import React from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

import Logo from '../Components/Logo';
import Loading from '../Components/Loading';

import styles from '../styles/DynamicModal.module.css';
import stylesLogo from '../styles/Logo.module.css';
import indexStyles from '../styles/Auth.module.css';

const Feedback = () => {
    const [dbStatus, setDbStatus] = React.useState('checking');
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const fetchData = async () => {
        try {
            const response = await axios.get('/api/health');
            if (response.status === 200) {
                setDbStatus('connected');
            }
        } catch (err) {
            setDbStatus('Отсутствует подключение к серверу');
        } finally {
            setLoading(false);
        }
        }

        fetchData();
    }, [])

    const [status, setStatus] = React.useState('');
    const [feedback, setFeedback] = React.useState('');
    const [email, setEmail] = React.useState('');

    const sendFeedback = (e) => {
        e.preventDefault();
    
        axios.post(`/api/feedback?email=${email}&message=${feedback}`)
        .then(() => {
          setStatus('Обращение успешно отправлено');
        })
        .catch((error) => {
          setStatus(`Ошибка отправки обращения:  ${error.response?.data.message || error.message}`);
        })
    }

    const navigate = useNavigate();
    const closeModal = () => {
        navigate('/')
    }

    return (
        <>
        {loading ? (
            <Loading />
        ) : dbStatus === 'connected' ? (
        <div className={indexStyles.indexMain}>
            <div className={indexStyles.indexForm}>
                <a style={{zIndex: '9999'}} className={stylesLogo.widthLimitation}><Logo to='/' position='fixed' /></a>
                <form className={styles.lining} onSubmit={(e) => sendFeedback(e)} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.header}>
                        <h1>Оставьте отзыв или опишите проблему</h1>
                        <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                        </svg>
                    </div>
                    <div className={styles.main}>
                        <a className={styles.statusPanel}>Обратите внимание: срок предоставления доступа к системе составляет до 3 дней.</a>
                        <a>Введите электронную почту для связи с вами</a>
                        <input type='text' placeholder='Введите e-mail' required value={email} onChange={(e) => setEmail(e.target.value)} />
                        <a>Введите текст обращения</a>
                        <textarea rows='10' placeholder='Опишите проблему' minLength='8' maxLength='10000' require='' value={feedback} onChange={(e) => setFeedback(e.target.value)}></textarea>
                        {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                        <button className='button maxWidth black'>Отправить</button>
                    </div>
                </form>
            </div>
        </div>
        ) : (
            <span style={{display: 'flex', flexDirection: 'column', padding: '10px', boxSizing: 'border-box'}}>
                <a>Система «Поток» в данный момент недоступна.</a>
                <a>Статус: {dbStatus}</a>
            </span>
        )}
        </>
    )
};

export default Feedback;
